export const environment = {
  production: true,
  environment_name: 'glen',
  environment_title: 'The Glen',
  environment_url: 'https://theglenshopping.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: 'c9ba5816-86fe-41a8-ae04-81b422e9e998',
  addressLat: -26.2681502865095,
  addressLng: 28.04845615505492,
  cinemaID: 17,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'eNdAxNdbdeStqQz70pU99c6Rw0z_IXSvYXg8cZItrMI',
  street_address: 'Cnr Orpen Rd &, Letaba Rd',
  address_locality: 'Oakdene',
  postal_code: '2001',
  address_country: 'ZA',
  contact_form_uuid: 'qs65jeim',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/db39acd9-e1f8-4116-bc7c-4399ce483151/d4d10ad0-9002-41b3-8c18-b2d242aa0e33.pdf',
  tiktok_url: 'https://www.tiktok.com/@theglen.shopping',
  sitemap_image:
    'https://cdn.hyprop.co.za/image/2021/8/29/7fddb280-071b-4634-a22b-86a8ddce6b88/8b4eeed0-5535-40ae-92e5-9c8326fb36aa.jpg',
  error_image:
    'https://cdn.hyprop.co.za/image/2023/11/23/76b0cd18-b44c-496e-b375-c02f7691a976/d3f0a0ac-bc9a-49e5-b636-bc8ac1d8edd6.jpg',
};
